import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { NavButton } from '../navigation/nav'
import { Button, Menu, MenuItem } from '@mui/material'
import { useNavigate } from 'react-router-dom'

const PromoBlockASBO = ({ children, buttonText, to, inverted, onModalOpen, withMenu = false }) => {
  const { t } = useTranslation()
  const btn = useRef(null)
  // const [anchorEl, setAnchorEl] = React.useState(null)
  // const open = Boolean(anchorEl)

  const navigate = useNavigate()
  const handleClick = r => {
    navigate('/asbo/book-a-demo')
  }

  return (
    <div className='container1300'>
      <div className={`br30 row mob-column `} style={{ backgroundColor: '#ffffff' }}>
        <div className='column column-center mob-text-center promo-block-asbo'>
          {children ? (
            children
          ) : (
            <p className='mb36 sato36 font500 mob-font-24'>
              {t('An all-new platform.')}
              <br />
              {t('An all-new world for security teams.')}
            </p>
          )}

          <Button
            sx={{
              background: '#0075BC',
              borderRadius: 0,
              padding: '22px 35px',
              letterSpacing: 1.6,
              cursor: 'pointer',
              color: '#fff',
              '&:hover': {
                background: '#336791'
              }
            }}
            ref={btn}
            onClick={handleClick}
            variant='dark'
            size='md'
          >
            Book a demo
          </Button>
        </div>
        <div className='get-started-home-asbo'></div>
      </div>
    </div>
  )
}

export default PromoBlockASBO
